import { render, staticRenderFns } from "./SCardProductLotComp.vue?vue&type=template&id=3cb24a22&"
import script from "./SCardProductLotComp.vue?vue&type=script&lang=js&"
export * from "./SCardProductLotComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports